// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OuT8","right":"styles_right__2lg91"};